__turbopack_context__.v({
  "button": "styles-module-scss-module__HoDjoW__button",
  "root": "styles-module-scss-module__HoDjoW__root",
});
